<app-rating [rating]="ratingCtrl.value" [editable]="true"></app-rating>
